/* eslint-disable no-shadow */
import { useEffect, useState } from 'react';
import {
  Autocomplete,
  TextField,
  Box,
} from '@mui/material';
import { cloneDeep, omit } from 'lodash';
import { useListJobTitleLazyQuery } from '../../../../graphql/generated/graphql';
import { IJobTitle, JobTitleProps } from '../../../config/interfaces';

const JobTitle = (props: JobTitleProps) => {
  const {
    value,
    formik,
    error,
    helperText,
    clear
  } = props;
  const [listJobTitle, { data }] = useListJobTitleLazyQuery();
  const [selectJobTitle, setSelectJobTitle] = useState<IJobTitle[]>([]);
  const [keyJobTitle, setkeyJobTitle] = useState<number>(0);

  //forcing to re-render to clear option selected
  const clearFieldName = () => {
    setkeyJobTitle(keyJobTitle + 1)
  }

  useEffect(() => {
    if (clear) {
      clearFieldName();
    }
  }, [clear])
  //

  useEffect(() => {
    listJobTitle();
  }, []);

  useEffect(() => {
    if (data?.listJobTitle) {
      const tempOptions = cloneDeep(data.listJobTitle);
      const result = tempOptions?.map((o) => ({
        label: o?.name,
        value: o?.id,
        ...omit(o, 'id'),
      }));
      setSelectJobTitle(result as []);
    }
  }, [data]);

  return (
    <Autocomplete
      fullWidth
      key={keyJobTitle}
      id="job-title"
      options={selectJobTitle}
      onChange={(event: any, newValue: any) => formik.setFieldValue('jobTitle', newValue.value)}
      renderOption={(props, option) => (
        <Box
          component="li"
          {...props}
          key={option.value}
        >
          {option.name}
        </Box>
      )}
      renderInput={(params) => (
        <TextField
          {...params}
          name="jobTitle"
          label="Job title"
          value={value}
          error={error}
          helperText={helperText}
        />
      )}
    />
  );
};

export default JobTitle;
